import { Dialog } from '@m/alchemy-ui/Dialog';

import { SNAPPY_URL } from 'settings/constants/snappy';
import * as Styled from './ConnectWithSnappyDialog.styled';

interface ConnectWithSnappyDialogProps {
  isOpen: boolean;
  dontShowAgain?: boolean;
  onClose?: () => void;
  onDismiss?: () => void;
  onAccept?: () => void;
  onDontShowAgainChange?: (dontShowAgain: boolean) => void;
}

export function ConnectWithSnappyDialog({
  isOpen,
  onClose = () => {},
  onDismiss = () => {},
  onAccept = () => {},
  dontShowAgain = false,
  onDontShowAgainChange = () => {},
}: ConnectWithSnappyDialogProps) {
  if (!isOpen) return null;

  return (
    <Dialog hasCloseIcon size="medium" isOpen={isOpen} onClose={onClose}>
      <Dialog.Header isCentered>Connect to Snappy</Dialog.Header>

      <Dialog.Body isCentered>
        <Styled.MedalliaSnappyLogo alt="Connect Snappy with Agent Connect" />

        <p>
          Agent Connect teamed up with{' '}
          <a href={SNAPPY_URL} rel="noopener noreferrer" target="_blank">
            Snappy
          </a>
          . When connected with Snappy, reward fulfillment is automated to save
          you time & money.
        </p>

        <Styled.InlineBlockCheckbox
          checked={dontShowAgain}
          label="Don't show this message again?"
          onChange={ev => onDontShowAgainChange(ev.target.checked)}
        />
      </Dialog.Body>

      <Styled.FlexDialogFooter>
        <Styled.FooterButton priority="secondary" onClick={onAccept}>
          Connect to my Snappy Account
        </Styled.FooterButton>

        <Styled.FooterButton priority="primary" onClick={onDismiss}>
          Continue with Agent Connect Rewards
        </Styled.FooterButton>
      </Styled.FlexDialogFooter>
    </Dialog>
  );
}
